var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7291 10.9392L17.1485 9.01503C16.7081 4.99116 13.7706 1.7887 9.20215 1.7887C4.05171 1.7887 1 5.37765 1 10.0119C1 13.3358 2.72412 14.8516 3.42675 17.1678C3.78126 18.3355 4.83656 19.1487 6.05633 19.1487H13.9396C15.2453 19.1487 16.37 18.2268 16.6267 16.9467L17.1055 14.5584L18.1325 14.0001C19.2481 13.3925 19.535 11.9205 18.7291 10.9392Z",
    fill: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28847 0.875C7.78412 0.875 7.37479 1.28433 7.37479 1.78868V9.25415C6.31017 9.63044 5.54742 10.6458 5.54742 11.8392C5.54742 13.3531 6.77464 14.5803 8.28848 14.5803C8.71171 14.5803 9.11253 14.4844 9.4704 14.3131L11.6755 16.5182C12.1927 17.0362 12.8816 17.3213 13.6134 17.3213H14.0151C14.331 17.8675 14.9216 18.235 15.598 18.235C16.6072 18.235 17.4253 17.4169 17.4253 16.4076C17.4253 15.3984 16.6072 14.5803 15.598 14.5803C14.9216 14.5803 14.331 14.9477 14.0151 15.4939H13.6134C13.3731 15.4939 13.1383 15.3971 12.9675 15.2262L10.7623 13.0211C10.9336 12.6633 11.0295 12.2624 11.0295 11.8392C11.0295 10.6458 10.2668 9.63043 9.20216 9.25414V1.78868C9.20216 1.28433 8.79282 0.875 8.28847 0.875Z",
    fill: "url(#paint0_linear_71_1471)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_1471",
    x1: 11.4864,
    y1: 0.875,
    x2: 11.4864,
    y2: 18.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportBlue);
export default __webpack_public_path__ + "static/media/support-blue.f7a7bf41b3a48a4609901b1d5f3201a2.svg";
export { ForwardRef as ReactComponent };